import { BankingService } from '@/modules/banking/services'

export const silentContactChange = (data, meta, processId) => {
  const { transactionId, provideContactChangeRequest: { token } } = data
  const requestData = { ...meta }

  return BankingService.psd2.callbacks.contactChange(token, requestData, processId)
    .then(() => {
      return data
    })
    .catch((error) => {
      error.transactionId = transactionId
      return Promise.reject(error)
    })
}

export default silentContactChange
